<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i> 实名相关</el-breadcrumb-item>
                <el-breadcrumb-item>防沉迷设置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='20'>
                        <el-form v-show='showSearch' ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select filterable clearable size='mini' v-model='queryParams.projectAppId'
                                           placeholder='项目名'>
                                    <el-option
                                        v-for='item in projectInfoList'
                                        :key='item.id'
                                        :label='item.cnName'
                                        :value='item.appId'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select clearable size='mini' v-model='queryParams.regionType' placeholder='区域'>
                                    <el-option
                                        v-for='item in regionTypeOption'
                                        :key='item.value'
                                        :label='item.label'
                                        :value='item.value'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='4'>
                        <el-button
                            icon='el-icon-plus'
                            plain
                            size='mini'
                            type='primary'
                            @click='handleAdd'
                        >新增
                        </el-button>
                        <el-button
                            icon='el-icon-menu'
                            plain
                            size='mini'
                            type='primary'
                            @click='handleSort'
                        >排序
                        </el-button>
                    </el-col>
                </el-row>
            </div>
            
            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='gameInfoList'
                      @sort-change='handleSortChange'
                      @selection-change='handleSelectionChange'>
                <!--<el-table-column align='center' type='selection' width='55' />-->
                <el-table-column :show-overflow-tooltip='true' align='center' label='项目名'>
                    <template slot-scope='scope'>
                        <span>{{ projectInfoMap.get(scope.row.projectAppId) }}</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='区域'>
                    <template slot-scope='scope'>
                        <el-tag size='mini' type='success' v-if='scope.row.regionType === "MAINLAND"'>大陆</el-tag>
                        <el-tag size='mini' type='warning' v-if='scope.row.regionType === "OVERSEAS"'>海外</el-tag>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='游戏描述' prop='describe' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='社区'>
                    <template slot-scope='scope'>
                        <span v-for='(item, index) in getCommunity(scope.row)'>
                            &nbsp;<el-tag>{{ item }}</el-tag>&nbsp;
                        </span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' sortable='custom' label='创建时间'
                                 prop='createTime' />
                <el-table-column fixed='right' align='center' width='200' class-name='small-padding fixed-width'
                                 label='操作'>
                    <template slot-scope='scope'>
                        <el-button
                            icon='el-icon-edit'
                            size='mini'
                            type='text'
                            @click='handleUpdate(scope.row)'
                        >修改
                        </el-button>
                        <el-button
                            icon='el-icon-delete'
                            size='mini'
                            type='text'
                            @click='handleDelete(scope.row)'
                        >删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-sizes='[15, 30, 45, 60, 75, 100, 200, 300]'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='sizes, prev, pager, next'
                    @size-change='handleSizeChange'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <!-- 添加或修改参数配置对话框 -->
            <el-dialog :title='title' :before-close='cancel' :visible.sync='open' append-to-body width='40%'>
                <el-form label-position='left' ref='form' label-width='150px'>
                    <el-form-item label='选择项目' prop='url'>
                        <el-select filterable clearable size='mini' v-model='currentGameInfo.projectAppId'
                                   placeholder='请选择'>
                            <el-option
                                v-for='item in projectInfoList'
                                :key='item.id'
                                :label='item.cnName'
                                :value='item.appId'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if='!updateStatus' label='选择区域' prop='url'>
                        <el-select size='mini' v-model='currentGameInfo.regionType' placeholder='请选择页面展示区域'>
                            <el-option
                                v-for='item in regionTypeOption'
                                :key='item.value'
                                :label='item.label'
                                :value='item.value'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='项目展示名' prop='url'>
                        <el-input size='mini' v-model='projectShowName' placeholder='如果需要自定义项目名字，请在此输入'/>
                    </el-form-item>
                    <el-form-item label='是否显示' prop='url'>
                        <el-tooltip class='item' effect='dark' content='选择关闭，则官网不会显示该项目的所有信息'
                                    placement='top-start'>
                            <el-switch v-model='showProjectInfo' />
                        </el-tooltip>
                    </el-form-item>
                    <el-form-item label='游戏简介' prop='url'>
                        <el-input type='textarea' :autosize='{ minRows: 8, maxRows: 30}' size='mini'
                                  v-model='currentGameInfo.describe' placeholder='请输入游戏简介' />
                    </el-form-item>
                    
                    <el-tabs v-model='backgroundImageActiveName'>
                        <el-alert
                            title='各端尺寸(宽*高) 电脑: 1920*1080, 平板: 1920*1080 手机: 1290 * 2796'
                            :closable='false' type='success'>
                        </el-alert>
                        <el-tab-pane label='官网PC端背景' name='pc'>
                            <el-form-item label='手动输入' prop='url'>
                                <el-input v-model='otherSetting.backgroundImage.pc' size='mini' />
                            </el-form-item>
                            <el-form-item label='文件上传' prop='url'>
                                <cotton-file-upload :data='gameDetailFileInfo'
                                                    :control-upload-behavior='true'
                                                    :auto-upload='true'
                                                    ref='file1'
                                                    trigger-type='text' :multiple='false'
                                                    accept='image/*' :limit='1'
                                                    @removeFile='handleRemoveFile($event, "pc")'
                                                    @fileUploadSuccess='handleFileUploadSuccess($event, "pc")' />
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane label='官网手机端端背景' name='phone'>
                            <el-form-item label='手动输入' prop='url'>
                                <el-input v-model='otherSetting.backgroundImage.phone' size='mini' />
                            </el-form-item>
                            <el-form-item label='文件上传' prop='url'>
                                <cotton-file-upload :data='gameDetailFileInfo'
                                                    :control-upload-behavior='true'
                                                    :auto-upload='true'
                                                    ref='file2'
                                                    trigger-type='text' :multiple='false'
                                                    accept='image/*' :limit='1'
                                                    @removeFile='handleRemoveFile($event, "phone")'
                                                    @fileUploadSuccess='handleFileUploadSuccess($event, "phone")' />
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane label='官网IPAD端背景' name='ipad'>
                            <el-form-item label='手动输入' prop='url'>
                                <el-input v-model='otherSetting.backgroundImage.ipad' size='mini' />
                            </el-form-item>
                            <el-form-item label='文件上传' prop='url'>
                                <cotton-file-upload :data='gameDetailFileInfo'
                                                    :control-upload-behavior='true'
                                                    :auto-upload='true'
                                                    ref='file3'
                                                    trigger-type='text' :multiple='false'
                                                    accept='image/*' :limit='1'
                                                    @removeFile='handleRemoveFile($event, "ipad")'
                                                    @fileUploadSuccess='handleFileUploadSuccess($event, "ipad")' />
                            </el-form-item>
                        </el-tab-pane>
                    </el-tabs>
                    <el-tabs v-model='activeName'>
                        <el-tab-pane label='游戏社区' name='gameCommunity'>
                            <dynamic-form warning-type='success'
                                          key-name='社区类型'
                                          value-name='社区地址'
                                          :generate-sort-json='true'
                                          :json-content='gameCommunity'
                                          :show-json-parse-button='false'
                                          warning-text='社区类型，填B站、微博等，社区地址，填B站等链接'
                                          @getDynamicJsonString='getCommunityDynamicJsonString' >
                                <template slot='table-operation' slot-scope='scope'>
                                    <el-button
                                        @click='handleGameCommunitySortValue(scope.data, scope.rowIndex)'
                                        type='text'
                                        size='small'>
                                        上移
                                    </el-button>
                                </template>
                            </dynamic-form>
                        </el-tab-pane>
                        <el-tab-pane v-if='updateStatus' label='游戏下载' name='gameDownload'>
                            <el-alert
                                style='margin-top: .5rem;margin-bottom: .5rem;'
                                title='输入之后，按回车键添加游戏下载项'
                                type='success'
                                :closable='false'>
                            </el-alert>
                            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }"
                                      :data='gameDownloadList'>
                                <!--<el-table-column align='center' type='selection' width='55' />-->
                                <el-table-column :show-overflow-tooltip='true' align='center' label='渠道'>
                                    <template slot-scope='scope'>
                                        <el-input @keyup.enter.native='handleUpdateGameDownload(scope.row)'
                                                  v-model='scope.row.channel' size='mini'
                                                  placeholder='请输入游戏渠道' />
                                    </template>
                                </el-table-column>
                                <el-table-column :show-overflow-tooltip='true' align='center' label='下载地址'>
                                    <template slot-scope='scope'>
                                        <el-input @keyup.enter.native='handleUpdateGameDownload(scope.row)'
                                                  v-model='scope.row.downloadUrl' size='mini'
                                                  placeholder='请输入游戏下载地址' />
                                    </template>
                                </el-table-column>
                                <el-table-column :show-overflow-tooltip='true' align='center' label='排序值'>
                                    <template slot-scope='scope'>
                                        <el-input @blur='updateGameDownloadSortValue(scope.row)' size='mini' type='number'
                                                  v-model='scope.row.sort' />
                                    </template>
                                </el-table-column>
                                <el-table-column fixed='right' align='center' width='200'
                                                 class-name='small-padding fixed-width'
                                                 label='操作'>
                                    <template slot-scope='scope' slot='header'>
                                        <el-button type='text' @click='handleAddGameDownload' size='mini'>增加一项
                                        </el-button>
                                    </template>
                                    <template slot-scope='scope'>
                                        <el-button
                                            v-if='!scope.row.addStatus'
                                            icon='el-icon-delete'
                                            size='mini'
                                            type='text'
                                            @click='handleDeleteGameDownload(scope.row)'
                                        >删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                </el-form>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>确 定</el-button>
                    <el-button @click='cancel'>取 消</el-button>
                </div>
            </el-dialog>
            
            <el-dialog title='游戏展示排序' :visible.sync='openGameSort' append-to-body width='40%'>
                <el-form label-position='left' ref='form' label-width='150px'>
                    <el-alert
                        title='选择区域后, 即可进行排序'
                        :closable='false'
                        style='margin-bottom: 1rem;'
                        type='success'>
                    </el-alert>
                    <el-form-item label='选择区域' prop='url'>
                        <el-select size='mini' @change='handleRegionChange' v-model='currentSortRegion'
                                   placeholder='请选择页面展示区域'>
                            <el-option
                                v-for='item in regionTypeOption'
                                :key='item.value'
                                :label='item.label'
                                :value='item.value'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='排序' prop='url'>
                        <div style='max-height: 50vh;overflow: scroll'>
                            <div v-for='(item, index) in sortGameList'
                                 :key='item.id'
                                 class='sort-item'
                                 @mouseenter='hoveredIndex = index'
                                 @mouseleave='hoveredIndex = null'>
                                <span>{{ projectInfoMap.get(item.projectAppId) }}</span>
                                <div class='sort-actions'>
                                    <el-popover
                                        placement='right'
                                        width='180'
                                        trigger='click'>
                                        <el-cascader
                                            filterable
                                            :options='getCascaderOptions(item)'
                                            @change='handleCascaderChange(item, $event)'
                                            placeholder='选择操作和目标位置'>
                                        </el-cascader>
                                        <el-button slot='reference' type='text'>排序</el-button>
                                    </el-popover>
                                </div>
                            </div>
                        </div>
                    
                    </el-form-item>
                
                </el-form>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='executeGameSort'>确 定</el-button>
                    <el-button @click='openGameSort = false'>取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </section>
</template>

<script>

import { message } from '@/utils/message';
import { deepCopy } from '@/utils/object';
import { queryProjectInfoList } from '@/components/api/ProjectInfo';
import { deleteGameInfo, insertGameInfo, queryGameInfo, updateGameInfo } from '@/components/api/GameInfo';
import {
    deleteGameDownload,
    insertGameDownload,
    queryGameDownload,
    updateGameDownload
} from '@/components/api/GameDownloadInfo';
import CottonFileUpload from '@/components/component/CottonFileUpload.vue';
import DynamicForm from '@/components/component/DynamicForm.vue';

export default {
    name: 'GameDetail',
    components: { DynamicForm, CottonFileUpload },
    data() {
        return {
            activeName: 'gameCommunity',
            backgroundImageActiveName: 'pc',
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            batchDeleteStatus: false,
            // 显示搜索条件
            showSearch: true,
            // 弹出层标题
            title: '',
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                projectAppId: undefined,
                sortSqlList: [
                    'createTime desc'
                ],
                regionType: undefined
            },
            updateStatus: false,
            projectInfoMap: new Map,
            projectInfoList: [],
            gameInfoList: [],
            gameDownloadList: [],
            gameDownloadListMap: new Map,
            currentGameInfo: {
                community: ''
            },
            gameCommunityList: [],
            gameDownloadObj: {
                download: ''
            },
            
            gameDetailFileInfo: {
                ownerType: 'GAME_PROJECT',
                accessType: 'PUBLIC',
                saveFolder: '/web/bg'
            },
            
            otherSetting: {
                backgroundImage: {
                    pc: undefined,
                    phone: undefined,
                    ipad: undefined
                }
            },
            showProjectInfo: true,
            projectShowName: undefined,
            regionTypeOption: [
                {
                    label: '大陆',
                    value: 'MAINLAND'
                },
                {
                    label: '海外',
                    value: 'OVERSEAS'
                }
            ],
            gameCommunity: undefined,
            
            openGameSort: false,
            sortGameList: [],
            originalGameList: [],
            currentSortRegion: undefined,
            
            hoveredIndex: -1
        };
    },
    created() {
        this.getList();
    },
    computed: {
        getCommunity() {
            return (row) => {
                if (!row.community) {
                    return ['未添加社区'];
                }
                let community = JSON.parse(row.community);
                let communityList = [];
                for (let i = 0; i < Object.keys(community).length; i++) {
                    communityList.push(Object.keys(community)[i]);
                    if (i === Object.keys(community).length - 1) {
                        return communityList;
                    }
                }
            };
        }
    },
    methods: {
        /** 查询字典类型列表 */
        getList() {
            this.reset();
            this.loading = true;
            queryGameInfo(this.queryParams).then(response => {
                if (response.code === 200) {
                    this.gameInfoList = response.data.result;
                    this.queryParams.total = response.data.total;
                    this.loading = false;
                    this.queryParams.pageNum = response.data.pageNum;
                } else {
                    this.loading = false;
                }
            });
            
            // 查询项目信息
            queryProjectInfoList({ pageSize: 100000 }).then(result => {
                if (result.code === 200) {
                    if (result.data && result.data.result) {
                        result.data.result.forEach(v => {
                            this.projectInfoList.push(v);
                            this.projectInfoMap.set(v.appId, v.cnName);
                        });
                    }
                }
            });
        },
        /** 提交按钮 */
        async submitForm() {
            this.otherSetting.show = this.showProjectInfo;
            this.otherSetting.projectShowName = this.projectShowName
            this.currentGameInfo.otherSetting = JSON.stringify(this.otherSetting, null, 0);
            if (this.updateStatus) {
                updateGameInfo(this.currentGameInfo).then(result => {
                    if (result.code === 200) {
                        message.success('修改成功');
                        this.handleAddGameDownload(this.currentGameInfo.projectAppId);
                        this.getList();
                        this.open = false;
                        this.$refs.file1.initFileList();
                        this.$refs.file2.initFileList();
                        this.$refs.file3.initFileList();
                    }
                });
            } else {
                insertGameInfo(this.currentGameInfo).then(result => {
                    if (result.code === 200) {
                        // 添加游戏的下载渠道
                        this.handleAddGameDownload(this.currentGameInfo.projectAppId);
                        message.success('添加成功');
                        this.getList();
                        this.open = false;
                        this.$refs.file1.initFileList();
                        this.$refs.file2.initFileList();
                        this.$refs.file3.initFileList();
                    }
                });
            }
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            this.$modal.confirm('是否确认删除"' + row.id + '"的数据项？').then(function() {
                return deleteGameInfo(row);
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('删除成功');
                }
            }).catch(() => {
            });
        },
        async handleSortChange({ column, prop, order }) {
            let sortType = null;
            if (order === 'ascending') {
                sortType = 'ASC';
            } else if (order === 'descending') {
                sortType = 'DESC';
            }
            
            let newSortSql = prop + ' ' + sortType;
            if (this.queryParams.sortSqlList.length > 0) {
                let sortAddStatus = false;
                for (let i = 0; i < this.queryParams.sortSqlList.length; i++) {
                    let sortSql = this.queryParams.sortSqlList[i];
                    if (sortSql.indexOf(prop) !== -1) {
                        // 存在排序sql
                        this.queryParams.sortSqlList.splice(i, 1);
                        if (order) {
                            this.queryParams.sortSqlList.push(newSortSql);
                        }
                        sortAddStatus = true;
                    }
                    if (i === this.queryParams.sortSqlList.length - 1) {
                        if (!sortAddStatus) {
                            this.queryParams.sortSqlList.push(newSortSql);
                        }
                    }
                }
            } else {
                this.queryParams.sortSqlList.push(newSortSql);
            }
            this.getList();
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList();
            this.resetGameDownload();
            this.gameCommunity = undefined
            this.$refs.file1.initFileList();
            this.$refs.file2.initFileList();
            this.$refs.file3.initFileList();
        },
        // 表单重置
        reset() {
            this.projectInfoList = [];
            this.gameDownloadList = [];
            this.projectInfoMap = new Map;
            this.projectInfoList = [];
            this.currentGameInfo = {};
            this.gameDownloadListMap = new Map;
            
            
        },
        resetGameDownload() {
            this.gameDownloadObj = {
                download: ''
            };
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                projectAppId: undefined,
                sortSqlList: [
                    'createTime desc'
                ],
                regionType: undefined
            };
            this.handleQuery();
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.resetGameDownload();
            this.open = true;
            this.title = '新增游戏详情';
            this.updateStatus = false;
            this.currentProjectSetting = {
                settingData: ''
            };
            this.gameCommunity = undefined
            
            this.otherSetting = {
                backgroundImage: {
                    pc: undefined,
                    phone: undefined,
                    ipad: undefined
                }
            };
        },
        handleBatchDelete() {
            let idList = this.ids;
            const obj = this;
            
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id);
            this.batchDeleteStatus = this.ids.length > 0;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.open = true;
            this.title = '修改游戏详情';
            this.updateStatus = true;
            this.currentGameInfo = deepCopy(row);
            this.gameCommunity = this.currentGameInfo.community
            if (this.currentGameInfo.otherSetting) {
                let parseData = JSON.parse(this.currentGameInfo.otherSetting);
                if (parseData.backgroundImage) {
                    this.otherSetting.backgroundImage.pc = parseData.backgroundImage.pc;
                    this.otherSetting.backgroundImage.phone = parseData.backgroundImage.phone;
                    this.otherSetting.backgroundImage.ipad = parseData.backgroundImage.ipad;
                }
                this.showProjectInfo = parseData.show;
                this.projectShowName = parseData.projectShowName
            } else {
                this.otherSetting = {
                    backgroundImage: {
                        pc: undefined,
                        phone: undefined,
                        ipad: undefined
                    }
                };
            }
            this.loadGameDownload(row.projectAppId, row.regionType);
        },
        loadGameDownload(projectAppId, regionType) {
            // 查询此项目的下载地址
            queryGameDownload({ projectAppId: projectAppId, regionType: regionType }).then(result => {
                if (result.code === 200) {
                    this.gameDownloadList = result.data.result;
                    this.gameDownloadList.sort((a, b) => a.sort - b.sort)
                    let downloadObj = {};
                    this.gameDownloadList.forEach((key, index) => {
                        downloadObj[key.channel] = key.downloadUrl;
                        this.gameDownloadListMap.set(key.channel, key.id);
                        if (index === this.gameDownloadList.length - 1) {
                            this.gameDownloadObj.download = JSON.stringify(downloadObj, null, 0);
                        }
                    });
                }
            });
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.pageNum = 1;
            this.getList();
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        getCommunityDynamicJsonString(jsonValue) {
            this.currentGameInfo.community = jsonValue;
        },
        getOtherSettingDynamicJsonString(jsonValue) {
            this.currentGameInfo.otherSetting = jsonValue;
        },
        getDownloadDynamicJsonString(jsonValue) {
            this.gameDownloadObj.download = jsonValue;
        },
        handleUpdateGameDownload(gameDownload) {
            if (gameDownload.addStatus) {
                if (gameDownload.downloadUrl) {
                    insertGameDownload(gameDownload).then(result => {
                        if (result.code === 200) {
                            message.success('新增成功');
                            this.loadGameDownload(gameDownload.projectAppId, this.currentGameInfo.regionType);
                        }
                    });
                }
            } else {
                updateGameDownload(gameDownload).then(result => {
                    if (result.code === 200) {
                        message.success('更新成功');
                        this.loadGameDownload(gameDownload.projectAppId, this.currentGameInfo.regionType);
                    }
                });
            }
        },
        handleDeleteGameDownload(gameDownload) {
            this.$modal.confirm('是否确认删除"' + gameDownload.channel + '"的数据项？').then(function() {
                return deleteGameDownload(gameDownload);
            }).then((result) => {
                if (result.code === 200) {
                    this.$modal.msgSuccess('删除成功');
                    this.loadGameDownload(gameDownload.projectAppId, this.currentGameInfo.regionType);
                }
            });
        },
        handleAddGameDownload() {
            this.gameDownloadList.push({
                projectAppId: this.currentGameInfo.projectAppId,
                addStatus: true,
                regionType: this.currentGameInfo.regionType
            });
        },
        handleFileUploadSuccess(fileInfo, type) {
            switch (type) {
                case 'pc':
                    this.otherSetting.backgroundImage.pc = fileInfo.url;
                    break;
                case 'phone':
                    this.otherSetting.backgroundImage.phone = fileInfo.url;
                    break;
                case 'ipad':
                    this.otherSetting.backgroundImage.ipad = fileInfo.url;
                    break;
            }
        },
        handleRemoveFile(fileInfo, type) {
            switch (type) {
                case 'pc':
                    this.otherSetting.backgroundImage.pc = undefined;
                    break;
                case 'phone':
                    this.otherSetting.backgroundImage.phone = undefined;
                    break;
                case 'ipad':
                    this.otherSetting.backgroundImage.ipad = undefined;
                    break;
            }
        },
        updateGameInfoSortValue(data) {
            updateGameInfo(data);
        },
        handleGameCommunitySortValue(communityList, index) {
            if (index === 0) {
                return
            }
            const element = communityList.splice(index, 1)[0];
            communityList.splice(index - 1, 0, element);
        },
        updateGameDownloadSortValue(currentGameDownload) {
            updateGameDownload(currentGameDownload)
        },
        handleSort() {
            this.openGameSort = true;
            this.sortGameList = [];
            this.originalGameList = [];
            this.currentSortRegion = undefined;
        },
        handleRegionChange(region) {
            if (!region) {
                return;
            }
            
            console.log(region);
            queryGameInfo({
                pageNum: 1,
                pageSize: 10000,
                sortSqlList: [
                    'sort asc'
                ],
                regionType: region
            }).then(response => {
                if (response.code === 200) {
                    this.sortGameList = response.data.result;
                    this.originalGameList = deepCopy(response.data.result);
                }
            });
        },
        executeGameSort() {
            if (this.sortGameList.length !== this.originalGameList.length) {
                this.$message.error('列表长度不匹配，无法比较排序。');
                return;
            }
            
            const changedItems = [];
            const originalItemsMap = new Map(this.originalGameList.map(item => [item.id, item]));
            
            // 修改sortGameList中的顺序
            for (let i = 0; i < this.sortGameList.length; i++) {
                this.sortGameList[i].sort = i;
            }
            
            this.sortGameList.forEach((currentItem) => {
                const originalItem = originalItemsMap.get(currentItem.id);
                
                if (originalItem.sort !== currentItem.sort) {
                    changedItems.push(currentItem);
                }
            });
            
            if (changedItems.length > 0) {
                changedItems.forEach((item, index) => {
                    updateGameInfo(item);
                    if (index === changedItems.length - 1) {
                        message.success('排序完成');
                    }
                });
            }
            this.openGameSort = false;
            this.hoveredIndex = -1;
        },
        getCascaderOptions(currentItem) {
            const targetGames = this.sortGameList
                .filter(item => item.id !== currentItem.id)
                .map(game => ({
                    value: game.id,
                    label: this.projectInfoMap.get(game.projectAppId)
                }));
            
            return [
                {
                    value: 'insertBefore',
                    label: '排到之前',
                    children: targetGames
                },
                {
                    value: 'insertAfter',
                    label: '排到之后',
                    children: targetGames
                }
            ];
        },
        handleCascaderChange(itemToMove, value) {
            if (!value || value.length < 2) {
                return;
            }
            
            const [action, targetItemId] = value;
            
            const fromIndex = this.sortGameList.findIndex(item => item.id === itemToMove.id);
            if (fromIndex === -1) {
                console.error('Item to move not found in list');
                return;
            }
            
            // Remove from original position
            const item = this.sortGameList.splice(fromIndex, 1)[0];
            
            const targetIndex = this.sortGameList.findIndex(item => item.id === targetItemId);
            if (targetIndex === -1) {
                console.error('Target item not found in list');
                // Re-add item if target is not found
                this.sortGameList.splice(fromIndex, 0, item);
                return;
            }
            
            let insertionIndex;
            if (action === 'insertBefore') {
                insertionIndex = targetIndex;
            } else { // 'insertAfter'
                insertionIndex = targetIndex + 1;
            }
            this.sortGameList.splice(insertionIndex, 0, item);
            
            // Close all popovers after action, requires a little trick
            document.body.click();
        }
    }
};
</script>
<style>
.sort-item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 10px;
    background-color: rgba(64, 158, 255, 0.13);
    margin-bottom: .5rem;
    border-radius: 10px;
    width: 300px;
    padding-left: .5rem;
    padding-right: .5rem;
}
</style>